import { render } from "./ListadoIPv4.vue?vue&type=template&id=5d6d2645"
import script from "./ListadoIPv4.vue?vue&type=script&lang=js"
export * from "./ListadoIPv4.vue?vue&type=script&lang=js"

import "./ListadoIPv4.vue?vue&type=style&index=0&id=5d6d2645&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__